export function normalizarTexto(texto) {
  if (!texto || typeof texto !== 'string') return '';

  texto = texto.toLowerCase();

  // Quitar acentos
  texto = texto.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  // Reemplazar caracteres no deseados por guiones
  texto = texto.replace(/[^a-z0-9\s-]/g, ''); // solo letras, números, espacios y guion
  texto = texto.replace(/\s+/g, '-'); // espacio por guion
  texto = texto.replace(/-+/g, '-');  // múltiples guiones por uno

  return texto.replace(/^-+|-+$/g, ''); // quitar guiones del inicio/final
}